<template>
    <slide-up-modal
        ref="modal"
        modal-id="defaultBuyerModal"
        modal-title="Destinataire des notifications mail"
        @modal-closed="$emit('close')"
    >
        <p>
            Choisissez l'utilisateur qui recevra les notifications mail du client.
        </p>

        <div class="form-group">
            <select class="form-control" v-model="selectedBuyerId">
                <option v-for="buyer in buyers" :key="buyer.id" :value="buyer.id">
                    {{ buyer.email }}{{ buyer.email_suppressed ? ' (email désactivé)' : '' }}
                </option>
            </select>
        </div>

        <div v-if="errorMessage" class="alert alert-danger" style="margin-top: 15px;">
            {{ errorMessage }}
        </div>

        <div class="actions" style="margin-top: 20px;">
            <button class="btn btn-complete btn-sm" @click="submit">Valider</button>
            <button class="btn btn-default btn-sm" @click="$emit('close')">Annuler</button>
        </div>
    </slide-up-modal>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'
import SlideUpModal from 'components/Modals/SlideUpModal'

export default {

    name: 'DefaultBuyerModal',

    components: { SlideUpModal },

    props: {
        customerId: {
            type: Number,
            required: true
        },

        buyers: {
            type: Array,
            required: true
        },

        currentBuyerId: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            selectedBuyerId: this.currentBuyerId,
            errorMessage: null
        }
    },

    methods: {
        ...mapActions('customer', ['updateDefaultBuyer']),

        submit() {
            if (this.selectedBuyerId === this.currentBuyerId) {
                this.$emit('close')
                return
            }

            const buyer = _.find(this.buyers, b => b.id === this.selectedBuyerId)

            if (!buyer) {
                return
            }

            this.errorMessage = null
            this.$refs.modal.isLoading = true

            // En cas de succès, la notification est gérée globalement par
            // formAxiosInterceptors + le plugin form-response-notificator
            // (« Client : Mis à jour avec succès. »), comme les autres éditions de la fiche.
            // En cas d'échec, on affiche un message d'erreur inline dans la modale.
            this.updateDefaultBuyer({ customerId: this.customerId, buyer })
                .then(() => this.$emit('close'))
                .catch(error => {
                    const data = error && error.response && error.response.data
                    // Erreurs de validation Laravel : data.errors = { champ: [messages] }.
                    // On récupère le premier message, quel que soit le champ concerné.
                    const firstError = _.chain(data && data.errors).values().flatten().head().value()
                    this.errorMessage = firstError
                        || 'La modification du destinataire a échoué. Veuillez réessayer.'
                })
                .then(() => {
                    if (this.$refs.modal) {
                        this.$refs.modal.isLoading = false
                    }
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/DefaultBuyerModal.vue